/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { DisconnectProviderResponse, DisconnectProviderVars } from '../openapi-types.gen.js';

export type { DisconnectProviderResponse, DisconnectProviderVars } from '../openapi-types.gen.js';

export const useDisconnectProvider = createMutationHook<DisconnectProviderVars, DisconnectProviderResponse, unknown>({
  specName: 'useDisconnectProvider',
  path: '/v1/auth/providers/{provider}',
  method: 'DELETE',
  resolveUrl: (vars: DisconnectProviderVars) => `/v1/auth/providers/${vars.provider}`,
  
  parseResponse: (raw: unknown): DisconnectProviderResponse => raw as DisconnectProviderResponse,
  optimistic: [{
    queryKey: ['auth', 'detail'],
    apply: (prev: any, vars: DisconnectProviderVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
